export default __webpack_public_path__ + "static/media/doopage_logo_white.efd40329.png";